import { Youtube, ArrowUpRight } from "lucide-react";
import { Reveal, MaskLines, Eyebrow } from "./motion";

const HAD = ["vontade de crescer.", "capacidade de aprender.", "ambição."];

export const CaseStudy = () => {
  return (
    <section id="caso" data-testid="case-study-maia" className="grain relative bg-navy py-24 text-white sm:py-36">
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
        <div className="flex flex-wrap items-end justify-between gap-6">
          <div>
            <Eyebrow dark num="05">Caso de Sucesso</Eyebrow>
            <h2 className="mt-6 font-display text-6xl font-black tracking-tight sm:text-8xl lg:text-[9rem] lg:leading-[0.9]">
              <MaskLines lines={[<>Sucesso <span className="text-orange">real.</span></>]} />
            </h2>
          </div>
          <Reveal className="flex items-center gap-6 rounded-[28px] border border-white/15 px-6 py-5" data-testid="case-study-stat">
            <span className="font-display text-6xl font-black text-orange">2</span>
            <span className="text-sm leading-snug text-slate-200">anos depois,<br /><strong className="text-white">abriu a segunda loja.</strong></span>
          </Reveal>
        </div>

        <div className="mt-16 grid gap-12 lg:grid-cols-12">
          <Reveal className="space-y-5 text-lg leading-relaxed text-slate-200 sm:text-xl lg:col-span-5">
            <p className="text-xl sm:text-2xl">Quando entrou na rede, o responsável da unidade <strong className="text-white">vinha da enfermagem.</strong></p>
            <p className="text-xl text-slate-300 sm:text-2xl">Não tinha um percurso relevante no imobiliário.</p>
          <a href="https://www.youtube.com/watch?v=kuQYlV0eddk" target="_blank" rel="noopener noreferrer" data-testid="maia-video-link" className="group mt-6 inline-flex items-center gap-3 rounded-full border border-white/25 px-6 py-3.5 font-display text-base font-bold text-white transition-[background-color,border-color,transform] duration-300 hover:-translate-y-1 hover:border-orange hover:bg-orange">
              <Youtube className="h-5 w-5" /> Ver o vídeo da SI Maia
              <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:rotate-45" />
            </a>
          <img src="/img/maia-recepcao.webp" alt="Receção da loja SI Maia" className="mt-8 aspect-[16/10] w-full rounded-[28px] object-cover" />
          </Reveal>
          <div className="lg:col-span-6 lg:col-start-7">
            <p className="font-mono text-sm uppercase tracking-[0.22em] text-orange">Mas tinha</p>
            {HAD.map((h, i) => (
              <Reveal key={h} delay={i * 0.1} className="border-b border-white/10 py-4 font-display text-3xl font-extrabold tracking-tight sm:text-4xl">
                {h}
              </Reveal>
            ))}
            <Reveal className="mt-10 text-base leading-relaxed text-slate-300 sm:text-lg">
              Ao fim de apenas dois anos abriu a segunda loja. Este é apenas um dos exemplos daquilo que acontece quando juntamos pessoas determinadas a um método comprovado.
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
};
